// TextField.tsx
import React from "react";
import { Input } from "@chakra-ui/react";
import { FieldWrapper } from "../../components/form/FieldWrapper";
import { NullableSwitch } from "../../components/form/NullableSwitch";
import { useDisabled, useNAState, isEmptyValue } from "../../utils/formField";

type Props = {
  field: any;
  value?: any;
  readOnly?: any;
  invalid?: boolean;     // invalid "esterno" (es. dal server)
  submitted?: boolean;   // true quando l'utente prova a salvare
};

const TextField: React.FC<Props> = ({ field, value = "", readOnly, invalid, submitted = false }) => {
  const nullable = field?.nullable === true;

  const { mode, setMode, text, setText } = useNAState({ value, nullable });
  const { ro, disabled } = useDisabled({ readOnly, nullable, mode });

  // È richiesto compilare ORA? (non nullable oppure nullable ma in modalità "val")
  const requiredNow = !nullable || mode === "val";

  // invalid “derivato” locale: mostra il tooltip se si è tentato il submit e il campo richiesto è vuoto
  const derivedInvalid = !!invalid || (submitted && requiredNow && isEmptyValue(text));

  return (
    <FieldWrapper field={field} invalid={derivedInvalid}>
      <NullableSwitch
        nullable={nullable}
        mode={mode}
        setMode={setMode}
        readOnly={ro}
      >
        <Input
          name={!ro && requiredNow ? field.name : undefined}
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          isDisabled={disabled}
          readOnly={ro}
        />
      </NullableSwitch>

      {ro && (
        <input
          type="hidden"
          name={field.name}
          value={nullable ? (mode === "na" ? "N/A" : text) : text}
        />
      )}
      {!ro && nullable && mode === "na" && (
        <input type="hidden" name={field.name} value="N/A" />
      )}
    </FieldWrapper>
  );
};

export default TextField;
